export default {
  props: {
    dataset: {
      type: Object,
      default: () => ({}),
    },
  },
  data: vm => ({
    propsClass: vm.dataset.class || '',
    needProof: false,
    modalName: 'call-order-modal-d',
    isOpenModal: false,
    hashName: 'call-order',
  }),
  mounted() {
    if (this.getHash(window.location) === this.hashName) {
      this.$nextTick(() => {
        this.openModal();
      });
    }

    window.addEventListener('popstate', this.handlerPopstate);
  },
  destroyed() {
    window.removeEventListener('popstate', this.handlerPopstate);
  },
  methods: {
    openModal() {
      this.$modal.show(this.modalName);
    },
    handlerNeedProof(isNeed) {
      this.needProof = isNeed;
    },
    handlerOpendModal() {
      window.location.hash = 'call-order';
      this.isOpenModal = true;
    },
    handlerClosedModal() {
      this.isOpenModal = false;
      this.needProof = false;
      window.history.replaceState(null, null, ' ');
    },
    getHash(location) {
      let hash = location.hash;
      if (hash.length) hash = hash.slice(1);
      return hash;
    },
    handlerPopstate(event) {
      const hash = this.getHash(event.target.location);

      if (this.isOpenModal && !hash.length) {
        this.$modal.hide(this.modalName);
      } else if (!!hash.length && hash === this.hashName && !this.isOpenModal) {
        this.openModal();
      }
    },
  },
};
